import { render, staticRenderFns } from "./NewBind.vue?vue&type=template&id=0f15cc5d&scoped=true&"
import script from "./NewBind.vue?vue&type=script&lang=js&"
export * from "./NewBind.vue?vue&type=script&lang=js&"
import style0 from "./NewBind.vue?vue&type=style&index=0&id=0f15cc5d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15cc5d",
  null
  
)

export default component.exports